// src/hooks/useKPIComparisons.js
import { useMemo } from 'react';

export const useKPIComparisons = (currentAnalytics, previousAnalytics) => {
  const comparisons = useMemo(() => {
    if (!previousAnalytics || !currentAnalytics) {
      return {
        callsComparison: null,
        leadsComparison: null,
        revenueComparison: null,
        efficiencyComparison: null,
        uniqueComparison: null
      };
    }

    const calculatePercentageChange = (current, previous) => {
      if (previous === 0) return current > 0 ? 100 : 0;
      return Math.round(((current - previous) / previous) * 100);
    };

    return {
      callsComparison: calculatePercentageChange(
        currentAnalytics.totalCalls, 
        previousAnalytics.totalCalls
      ),
      leadsComparison: calculatePercentageChange(
        currentAnalytics.leadCalls, 
        previousAnalytics.leadCalls
      ),
      revenueComparison: calculatePercentageChange(
        currentAnalytics.totalRevenue, 
        previousAnalytics.totalRevenue
      ),
      efficiencyComparison: calculatePercentageChange(
        currentAnalytics.leadEfficiency, 
        previousAnalytics.leadEfficiency
      ),
      nonLeadsComparison: calculatePercentageChange(
        currentAnalytics.nonLeadCalls, 
        previousAnalytics.nonLeadCalls
      ),
      uniqueComparison: calculatePercentageChange(
        currentAnalytics.totalUnique || 0, 
        previousAnalytics.totalUnique || 0
      )
    };
  }, [currentAnalytics, previousAnalytics]);

  return comparisons;
};
